import styled from 'styled-components';

export const OverlayBackdrop = styled.div`
	position: fixed;
	inset: 0;
	background: ${({ theme }) => theme.colors.blackOverlay};
	z-index: ${({ theme }) => theme.zIndexes.modal};
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 12px;

	@media (max-width: ${({ theme }) => theme.breakpoints.md}) {
		padding: 6px;
	}
`;

export const CloseButton = styled.button`
	position: absolute;
	top: 40px;
	right: 40px;
	background: transparent;
	border: 0;
	border-radius: 0;
	cursor: pointer;
	color: ${({ theme }) => theme.colors.black};
	line-height: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 48px;
	height: 48px;
	padding: 0;
	z-index: 1;
	font-size: 2rem;

	&:hover {
		color: ${({ theme }) => theme.colors.primaryLight};
	}

	&:focus-visible {
		outline-offset: 3px;
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.md}) {
		top: max(12px, env(safe-area-inset-top));
		right: max(12px, env(safe-area-inset-right));
		width: 44px;
		height: 44px;
		color: ${({ theme }) => theme.colors.primaryDark};
	}
`;

export const PopupContent = styled.div`
	position: relative;
	--overlay-fluid-width: clamp(
		340px,
		calc(340px + (1200 - 340) * ((100vw - 340px) / (1200 - 340))),
		1200px
	);
	--overlay-fluid-height: clamp(
		520px,
		calc(520px + (600 - 520) * ((100vw - 340px) / (1200 - 340))),
		600px
	);
	--overlay-mobile-fluid-height: clamp(
		600px,
		calc(600px + (820 - 600) * ((100vw - 340px) / (768 - 340))),
		820px
	);
	color: ${({ theme }) => theme.colors.primaryLight};
	background-image: ${({ $desktopBackgroundImage }) =>
		$desktopBackgroundImage ? `url(${$desktopBackgroundImage})` : 'none'};
	object-fit: cover;
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
	text-align: center;
	display: flex;
	width: min(100%, var(--overlay-fluid-width));
	height: min(calc(100dvh - 24px), var(--overlay-fluid-height));
	max-height: calc(100dvh - 24px);
	padding: 33px 125px;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	.start-page-overlay__content {
		display: flex;
		max-width: 900px;
		width: 100%;
		flex-direction: column;
		align-items: center;
		gap: 70px;
	}

	.start-page-overlay__content h1 {
		margin: 0;
		max-width: 900px;
		text-align: center;
		text-transform: uppercase;
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.md}) {
		background-image: ${({
			$phoneBackgroundImage,
			$desktopBackgroundImage,
		}) =>
			$phoneBackgroundImage
				? `url(${$phoneBackgroundImage})`
				: $desktopBackgroundImage
					? `url(${$desktopBackgroundImage})`
					: 'none'};
		width: min(100%, var(--overlay-fluid-width));
		height: min(calc(100dvh - 12px), var(--overlay-mobile-fluid-height));
		max-height: calc(100dvh - 12px);
		padding: 72px 24px 28px;
		background-position: center top;
		justify-content: center;

		.start-page-overlay__content {
			max-width: 280px;
			gap: 60px;
		}

		.start-page-overlay__content h1 {
			max-width: 310px;
		}
	}
`;
